module.exports = __webpack_public_path__ + "img/Vector 8 (1).dc22b165.png";